export enum AzureBlobFields {
  bucketPath = 'bucketPath',
  // eslint-disable-next-line spellcheck/spell-checker
  containerSasUrl = 'containerSasUrl',
}

export enum GCSFields {
  bucketName = 'bucketName',
  bucketPath = 'bucketPath',
  credentials = 'credentials',
}

export enum S3Fields {
  accessKey = 'accessKey',
  bucketName = 'bucketName',
  bucketPath = 'bucketPath',
  region = 'region',
  secretKey = 'secretKey',
}

export enum YandexFields {
  accessKey = 'accessKey',
  bucketName = 'bucketName',
  bucketPath = 'bucketPath',
  region = 'region',
  secretKey = 'secretKey',
}

export enum DefaultIntegrationFieldValues {
  bucketName = 'my-bucket',
  bucketPath = 'my-path',
}

export const IntegrationFields = {
  azure_blob: Object.values(AzureBlobFields),
  gcs: Object.values(GCSFields),
  s3: Object.values(S3Fields),
  yandex: Object.values(YandexFields),
};
